import React, { useState, useEffect } from 'react';
import { useApp } from '../data/ColisContext';
import { BRAND } from '../data/constants';
import { focusInput, blurInput, inputStyle } from '../utils/helpers';

export default function ModalAffecter({ colisId, onClose }) {
  const { colis, affecterLivreur } = useApp();
  const [livreur, setLivreur] = useState('');

  const pkg = colis.find(c => c.id === colisId);

  useEffect(() => {
    if (colisId) setLivreur('');
  }, [colisId]);

  if (!colisId || !pkg) return null;

  const handleConfirm = () => {
    if (!livreur.trim()) return;
    affecterLivreur(colisId, livreur.trim());
    onClose();
  };

  const handleKey = (e) => {
    if (e.key === 'Enter') handleConfirm();
    if (e.key === 'Escape') onClose();
  };

  return (
    <div
      style={{
        position:       'fixed',
        inset:          0,
        background:     'rgba(0,0,0,0.5)',
        zIndex:         1000,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        padding:        20,
        backdropFilter: 'blur(4px)',
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div style={{
        background:   'white',
        borderRadius: 20,
        padding:      32,
        width:        '100%',
        maxWidth:     420,
        boxShadow:    '0 24px 64px rgba(0,0,0,0.2)',
        animation:    'fadeIn 0.2s ease-out',
      }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 6 }}>
          🛵 Affecter un livreur
        </div>
        <div style={{ fontSize: 13, color: '#64748b', marginBottom: 24 }}>
          Colis <strong style={{ color: BRAND.primary }}>{pkg.id}</strong> → Zone {pkg.zone}
        </div>

        {/* Infos colis */}
        <div style={{ background: '#f8fafc', borderRadius: 12, padding: '12px 16px', marginBottom: 20 }}>
          <div style={{ fontSize: 13, color: '#475569' }}>
            <span style={{ fontWeight: 600 }}>Destinataire :</span> {pkg.destinataire}
          </div>
          <div style={{ fontSize: 13, color: '#475569', marginTop: 4 }}>
            <span style={{ fontWeight: 600 }}>Adresse :</span> {pkg.adresse}
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{
            display: 'block', fontSize: 12, fontWeight: 700, color: '#475569',
            marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.8px',
          }}>
            Nom du livreur *
          </label>
          <input
            autoFocus
            value={livreur}
            onChange={e => setLivreur(e.target.value)}
            onKeyDown={handleKey}
            placeholder="Ex: Cheikh Mbaye"
            style={inputStyle}
            onFocus={focusInput}
            onBlur={blurInput}
          />
        </div>

        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={handleConfirm}
            disabled={!livreur.trim()}
            style={{
              flex:         1,
              padding:      '13px',
              background:   livreur.trim() ? BRAND.gradient : '#e2e8f0',
              color:        livreur.trim() ? 'white'         : '#94a3b8',
              border:       'none',
              borderRadius: 12,
              fontWeight:   700,
              fontSize:     14,
              cursor:       livreur.trim() ? 'pointer' : 'not-allowed',
              fontFamily:   'inherit',
              transition:   'all 0.2s',
            }}
          >
            ✅ Confirmer l'affectation
          </button>
          <button
            onClick={onClose}
            style={{
              padding:      '13px 20px',
              background:   '#f1f5f9',
              color:        '#475569',
              border:       'none',
              borderRadius: 12,
              fontWeight:   600,
              fontSize:     14,
              cursor:       'pointer',
              fontFamily:   'inherit',
            }}
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}
